export default __webpack_public_path__ + "static/media/tetfund.9a17d59f.jpeg";